import { SlateLogo } from '@carvana/ds-icons';
import React from 'react';
import { useSlate } from '|/context';
import styles from './slate-footer.module.css';

const SlateFooter: React.FC = () => {
  const { isSlateVehicle } = useSlate();

  if (!isSlateVehicle) return null;

  return (
    <footer className={styles.footer}>
      <SlateLogo className={styles.logo} color="currentColor" />
      <p className={styles.copyright}>
        Copyright © {new Date().getFullYear()} Carvana, LLC. All Rights Reserved.
      </p>
    </footer>
  );
};

export default SlateFooter;
